import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { PeriodontogramaConfigComponent } from "./periodontograma-config.component";

@NgModule({
  declarations: [PeriodontogramaConfigComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatSnackBarModule,
    MatCardModule,
    MatIconModule,
  ],
  exports: [PeriodontogramaConfigComponent],
})
export class PeriodontogramaConfigModule {}
